import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../../utils/styledComponent';
import theme from '../../../theme';

const StyledTextarea = styledComponent('textarea', {
  padding: theme.spacing.inputPadding,
  border: theme.borders.input,
  borderRadius: theme.radii.input,
  ...theme.typography.label,
  color: theme.colors.textBody,
  width: '100%',
  boxSizing: 'border-box',
  minHeight: theme.sizes.textareaMinHeight,
  resize: 'vertical',
  transition: theme.transitions.default,
  '&:hover': {
    borderColor: theme.colors.infoBlue,
  },
  '&:focus': {
    outline: 'none',
    borderColor: theme.colors.infoBlue,
    boxShadow: `0 0 0 2px ${theme.colors.infoBlue}33`,
  },
  '&:disabled': {
    background: theme.colors.bgMuted,
    color: theme.colors.textMuted,
    cursor: 'not-allowed',
  },
});

function Textarea({
  id,
  value,
  onChange,
  placeholder,
  rows,
  disabled,
  style,
  dataTestId,
  'aria-label': ariaLabel,
}) {
  return (
    <StyledTextarea
      id={id}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      style={style}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    />
  );
}

Textarea.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  style: PropTypes.object,
  dataTestId: PropTypes.string,
  'aria-label': PropTypes.string,
};

Textarea.defaultProps = {
  id: undefined,
  value: undefined,
  onChange: undefined,
  placeholder: undefined,
  rows: undefined,
  disabled: false,
  style: undefined,
  dataTestId: undefined,
  'aria-label': undefined,
};

export default Textarea;
